import React from 'react';
import '../App.css';

const aboutSections = [
  {
    img: 'https://via.placeholder.com/200',
    text: 'Event planning',
    imgLeft: true,
  },
  {
    img: 'https://via.placeholder.com/200',
    text: 'Updated information',
    imgLeft: true,
  }
];

export default function About() {
  return (
    <div className="About-page">
      <div className="About-content">
        {aboutSections.map((section, idx) => (
          <div
            className={`About-section ${section.imgLeft ? 'img-left' : 'img-right'}`}
            key={idx}
          >
            <img src={section.img} alt="" className="About-img" />
            <p>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}